import {jQuery as $, lodash as _} from 'lib/shim';



export let raf = window.requestAnimationFrame
	|| window.webkitRequestAnimationFrame
	|| window.mozRequestAnimationFrame
	|| window.msRequestAnimationFrame
	|| function(callback){ return setTimeout(callback, 16); };



class AsyncDomClass {

	constructor(){
		this._getStack = [];
        this._setStack = [];
        this._queueRunning = false;
	}



	get(fGet){
		$.assert($.isFunction(fGet), 'AsyncDomClass.get | fGet is not a function');

		let taskId = $.randomUuid(true);

		this._getStack.push({
			id: taskId,
			task : fGet
		});
		this.startQueue();

		return taskId;
	}



	set(fSet){
		$.assert($.isFunction(fSet), 'AsyncDomClass.set | fSet is not a function');

		let taskId = $.randomUuid(true);

		this._setStack.push({
			id: taskId,
			task : fSet
		});
		this.startQueue();

		return taskId;
	}



	cancel(taskId){
		let found = false;

		$.each(this._getStack, (index, stackItem) => {
			if( stackItem.id === taskId ){
                this._getStack = $.removeFromArray(this._getStack, index, index + 1);
				found = true;
				return false;
			}
		});

		if( !found ){
			$.each(this._setStack, (index, stackItem) => {
				if( stackItem.id === taskId ){
					this._setStack = $.removeFromArray(this._setStack, index, index + 1);
					found = true;
					return false;
				}
			});
		}

		return found;
	}



	startQueue(){
		if( !this._queueRunning ){
			this._queueRunning = true;
			raf(() => { this._runTasks(); });
		}
	}



	_runTasks(){
		try {
			let stackItem;

			while( stackItem = this._getStack.shift() ){
				stackItem.task();
			}

			while( stackItem = this._setStack.shift() ){
				stackItem.task();
			}
		} catch (ex) {
			$.warn('AsyncDomClass._runTasks | a task errored with "'+ex+'".');
		}

		this._queueRunning = false;
		if(
			(this._getStack.length > 0)
			|| (this._setStack.length > 0)
		){
			this.startQueue();
		}
	}

}

export let AsyncDom = new AsyncDomClass();



export function waitForRepaint(callback){
	raf(() => {
		raf(() => {
			callback();
		});
	});
}
